var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('side-bar'),_c('main',{staticClass:"main-content position-relative max-height-vh-100 h-100 border-radius-lg"},[_c('top-navbar'),_c('dashboard-content',{on:{"click":_vm.toggleSidebar}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }